import { CloseableAlert } from 'components/alerts';

import { getDocsLink } from '@cast/utils';

import { ExternalLink, Typography, Stack } from '@cast/design-system';

const alertId = 'eks-hibernation-warning-alert';

type EksHibernationWarningAlertProps = {
  isCompact?: boolean;
};

export const EksHibernationWarningAlert = ({
  isCompact = false,
}: EksHibernationWarningAlertProps) => {
  return (
    <CloseableAlert
      closeable={alertId}
      testId={alertId}
      title="Additional setup required for EKS clusters"
      titleSx={{ typography: 'P12B' }}
      color="info"
      noIcon={isCompact}
    >
      <Stack gap={8}>
        {!isCompact ? (
          <>
            <Typography variant="P12R">
              To use hibernation with EKS, you must first configure required IAM
              permissions and node group settings.
            </Typography>
            <ExternalLink
              link={getDocsLink('docs_hibernation_aws_requirements')}
              sx={{ typography: 'P12M' }}
            >
              Documentation
            </ExternalLink>
          </>
        ) : (
          <Typography variant="P12R">
            To use hibernation with EKS, you must first configure required IAM
            permissions and node group settings.{' '}
            <ExternalLink
              link={getDocsLink('docs_hibernation_aws_requirements')}
              noIcon
              sx={{ textDecoration: 'underline', color: 'inherit' }}
            >
              Documentation
            </ExternalLink>
          </Typography>
        )}
      </Stack>
    </CloseableAlert>
  );
};
